import React, { FC } from 'react'
import { Grid, Typography, IconButton } from '@mui/material'
import { makeStyles } from '@mui/styles'
import CreateIcon from '@mui/icons-material/Create'
import DeleteIcon from '@mui/icons-material/Delete'
import clsx from 'clsx'

const useStyles = makeStyles({
  container: {
    width: 632,
    margin: '0 auto',
  },
  account: {
    maxWidth: 500,
    marginTop: 32,
    marginBottom: 32,
  },
  accName: {
    marginRight: 32,
    opacity: 0.75,
    fontWeight: 'bold',
  },
  accItem: {
    marginRight: 32,
    fontWeight: 400,
  },
  icon: {
    marginRight: 16,
  },
  isHidden: {
    display: 'none',
  },
})

interface AnotherTableProps {
  fullName: string
  email: string
  role?: string
  onEdit?: () => void
  onDelete?: () => void
  // eslint-disable-next-line
  hidden?: boolean | any
}

export const AddAnotherTable: FC<AnotherTableProps> = ({ fullName, email, role, onEdit, onDelete, hidden = false }) => {
  const classes = useStyles()

  return (
    <Grid className={clsx(classes.container, hidden ? classes.isHidden : undefined)}>
      <Grid container direction={'row'} justifyContent={'space-between'} alignItems={'center'} wrap={'nowrap'}>
        <Grid item container className={classes.account} xs={10} wrap={'nowrap'}>
          <Grid item>
            <Typography className={classes.accName} variant={'body2'}>
              {fullName}
            </Typography>
          </Grid>
          <Grid item className={classes.accItem}>
            <Typography variant={'body2'}>{email}</Typography>
          </Grid>
          {role && (
            <Grid item className={classes.accItem}>
              <Typography variant={'body2'}>{`${role.charAt(0).toUpperCase()}${role.slice(1)}`}</Typography>
            </Grid>
          )}
        </Grid>
        <Grid item>
          <IconButton className={classes.icon} size={'small'} onClick={onEdit}>
            <CreateIcon fontSize={'small'} />
          </IconButton>
          <IconButton size={'small'} onClick={onDelete}>
            <DeleteIcon fontSize={'small'} />
          </IconButton>
        </Grid>
      </Grid>
      <hr style={{ color: '#ebebeb', opacity: 0.6 }} />
    </Grid>
  )
}
